import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { ChevronDown } from 'lucide-react';

type FormatType = 'number' | 'datetime';

interface DecimalsButtonProps {
  decimals: number;
  formatType: FormatType;
  onChange: (formatType: FormatType, decimals?: number) => void;
  onOpenCustomDecimals?: () => void;
  hideTimestamp?: boolean;
}

const OPTIONS = [
  { label: '0 Decimals', value: { type: 'number' as FormatType, decimals: 0 } },
  { label: '6 Decimals', value: { type: 'number' as FormatType, decimals: 6 } },
  {
    label: '18 Decimals',
    value: { type: 'number' as FormatType, decimals: 18 },
  },
];

export function DecimalsButton({
  decimals,
  formatType,
  onChange,
  onOpenCustomDecimals,
  hideTimestamp,
}: DecimalsButtonProps) {
  const display =
    formatType === 'datetime' ? 'Timestamp' : `${decimals ?? 0} Decimals`;

  const handleSelect = (type: FormatType, nextDecimals?: number) => {
    onChange(type, nextDecimals);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className="h-8 px-3 py-0 text-sm font-medium text-foreground gap-2"
        >
          {display}
          <ChevronDown className="h-4 w-4 opacity-70" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-44">
        {OPTIONS.map((option) => (
          <DropdownMenuItem
            key={option.label}
            onSelect={() =>
              handleSelect(option.value.type, option.value.decimals)
            }
          >
            {option.label}
          </DropdownMenuItem>
        ))}
        <DropdownMenuItem
          onSelect={() => {
            onOpenCustomDecimals?.();
          }}
        >
          Custom Decimals
        </DropdownMenuItem>
        {!hideTimestamp && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onSelect={() => handleSelect('datetime', 0)}>
              Timestamp
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
